"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TrieNode = /** @class */ (function () {
    function TrieNode(prefix) {
        this.prefix = prefix;
        this.children = {};
        this.id = null;
    }
    return TrieNode;
}());
var RadixTrie = /** @class */ (function () {
    function RadixTrie() {
        this.root = new TrieNode("");
    }
    RadixTrie.prototype.commonPrefixLength = function (a, b) {
        var len = 0;
        while (len < a.length && len < b.length && a[len] === b[len]) {
            len++;
        }
        return len;
    };
    RadixTrie.prototype.insert = function (str, id) {
        var _a;
        var strLower = str.toLowerCase();
        var node = this.root;
        var i = 0;
        while (i < strLower.length) {
            var key = strLower[i];
            var childExists = key in node.children;
            if (!childExists) {
                // Add new string and short-circuit
                var newNode = new TrieNode(strLower.slice(i));
                newNode.id = id;
                node.children[key] = newNode;
                break;
            }
            node = node.children[key];
            var prefixLen = this.commonPrefixLength(strLower.slice(i), node.prefix.toLowerCase());
            i += prefixLen;
            if (prefixLen < node.prefix.length) {
                // Split existing node due to common prefix
                var newChild = new TrieNode(node.prefix.slice(prefixLen));
                newChild.children = node.children;
                newChild.id = node.id;
                node.prefix = node.prefix.slice(0, prefixLen);
                node.children = (_a = {}, _a[newChild.prefix[0]] = newChild, _a);
                node.id = i === strLower.length ? id : null;
            }
        }
    };
    RadixTrie.prototype.search = function (str) {
        var ids = [];
        var strLower = str.toLowerCase();
        var node = this.root;
        var i = 0;
        while (i < strLower.length) {
            var key = strLower[i];
            var childExists = key in node.children;
            if (!childExists) {
                return null;
            }
            node = node.children[key];
            var prefixLen = this.commonPrefixLength(strLower.slice(i), node.prefix.toLowerCase());
            if (prefixLen !== node.prefix.length) {
                break;
            }
            i += prefixLen;
            if (i === strLower.length) {
                break;
            }
        }
        var nodes = [node];
        while (nodes.length > 0) {
            var node_1 = nodes.pop();
            if (node_1) {
                if (node_1.id !== null) {
                    ids.push(node_1.id);
                }
                for (var char in node_1.children) {
                    nodes.push(node_1.children[char]);
                }
            }
        }
        return ids;
    };
    return RadixTrie;
}());
exports.default = RadixTrie;
